// Centralized fetch wrapper that ensures session persistence across refreshes.
// Sends both:
//  - credentials: 'include' so the httpOnly cookie travels in same-site contexts
//  - Authorization: Bearer <token> when localStorage holds a token (survives
//    third-party cookie blocking by Safari/Chrome on cross-domain prod hosts).
//
// The backend's get_current_user() accepts either, so the two paths are equivalent.

export const TOKEN_KEY = 'sim360_access_token';

export const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
};

export const setToken = (token) => {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {}
};

export const clearToken = () => setToken(null);

export const apiFetch = (input, init = {}) => {
  const token = getToken();
  const headers = new Headers(init.headers || {});
  if (token && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  return fetch(input, {
    ...init,
    credentials: init.credentials || 'include',
    headers,
  });
};
